var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"mr-1",attrs:{"to":{ name: _vm.$options.guidelineRoute }}},[_c('app-icon',{attrs:{"icon":"help","is-cursor-pointer":true,"size":25}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }